import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'app-toast-container',
    standalone: true,
    imports: [CommonModule], template: `
    <div class="toast-container position-fixed end-0 p-3" style="top: 70px; z-index: 1050;">
      <div 
        *ngFor="let toast of toasts" 
        class="toast show align-items-center border-0" 
        [ngClass]="toast.classname"
        role="alert" 
        aria-live="assertive" 
        aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body">
            {{ toast.message }}
          </div>
          <button 
            type="button" 
            class="btn-close btn-close-white me-2 m-auto" 
            [attr.aria-label]="toast.action"
            (click)="notificationService.remove(toast)">
          </button>
        </div>
      </div>
    </div>
  `,
    styles: [`
    .toast-container {
      max-width: 500px;
    }
    
    .toast {
      margin-bottom: 0.5rem;
      animation: slideInRight 0.3s ease-out;
    }
    
    .toast.hide {
      animation: slideOutRight 0.3s ease-out;
    }
    
    .toast-body {
      padding: 0.75rem;
      word-break: break-word;
    }
    
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
    
    /* Custom styles for different notification types */
    .bg-success {
      background-color: #198754 !important;
    }
    
    .bg-danger {
      background-color: #dc3545 !important;
    }
    
    .bg-warning {
      background-color: #ffc107 !important;
      color: #000 !important;
    }
    
    .bg-info {
      background-color: #0dcaf0 !important;
    }
    
    .text-light {
      color: #f8f9fa !important;
    }
    
    .text-dark {
      color: #212529 !important;
    }
    
    .btn-close-white {
      filter: invert(1) grayscale(100%) brightness(200%);
    }
  `]
})
export class ToastContainerComponent implements OnDestroy {
    private autoRemoveTimers: Map<number, any> = new Map(); // Usa l'ID del toast come chiave
    toasts: any[] = []; // Array locale per il template
    constructor(public notificationService: NotificationService) {
        // Sottoscrivi all'Observable per aggiornare i toast
        this.setupToastSubscription();
    }

    private setupToastSubscription(): void {

        // Sottoscrivi all'Observable dei toast
        this.notificationService.toasts$.subscribe(toasts => {


            // Confronta i toast per vedere quali sono nuovi
            const nuoviToast = toasts.filter(newToast =>
                !this.toasts.find(oldToast => oldToast.id === newToast.id)
            );

            if (nuoviToast.length > 0) {
                nuoviToast.forEach(toast => this.setupAutoRemoveForToast(toast));
            }

            // Aggiorna l'array locale
            this.toasts = [...toasts];

        });
    }

    private setupAutoRemoveForToast(toast: any): void {
        if (toast.delay && toast.delay > 0 && toast.id) {
            // Rimuovi timer esistente per questo ID se presente
            if (this.autoRemoveTimers.has(toast.id)) {
                clearTimeout(this.autoRemoveTimers.get(toast.id));
            }


            const timer = setTimeout(() => {
                this.notificationService.removeById(toast.id);
                this.autoRemoveTimers.delete(toast.id);
            }, toast.delay);

            this.autoRemoveTimers.set(toast.id, timer);
        } else {
            console.warn(`⚠️ [ToastContainer] Toast saltato (invalid delay o missing ID):`, {
                id: toast.id,
                delay: toast.delay,
                message: toast.message
            });
        }
    }
    ngOnDestroy(): void {
        // Clear all timers when component is destroyed
        this.autoRemoveTimers.forEach((timer, id) => {
            clearTimeout(timer);
        });
        this.autoRemoveTimers.clear();
    }
}
